module.exports = __webpack_public_path__ + "img/camp_shirt_gk5.14ed8895.svg";